var Vt = Object.defineProperty;
var Yt = (t, e, n) => e in t ? Vt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var L = (t, e, n) => Yt(t, typeof e != "symbol" ? e + "" : e, n);
import { parseEther as nt, isAddress as $t, http as Xt } from "viem";
import { getAccount as ie, watchAccount as it, watchChainId as Zt, connect as Qt, disconnect as Jt, signMessage as qt, signTypedData as en, sendTransaction as tn, estimateGas as nn, switchChain as rn, getBalance as on, getTransactionCount as cn } from "wagmi/actions";
import { walletConnect as sn, baseAccount as an } from "wagmi/connectors";
import { WagmiAdapter as dn } from "@reown/appkit-adapter-wagmi";
import { modal as ln, createAppKit as un } from "@reown/appkit/react";
import { createStorage as fn, cookieStorage as hn } from "wagmi";
import { useRef as M, useEffect as F, useState as le, createContext as ge, useContext as Ie, useMemo as j, useInsertionEffect as mn, useCallback as U, useLayoutEffect as ue, memo as Ze } from "react";
import { jsx as E, Fragment as Ct, jsxs as O } from "react/jsx-runtime";
import { Text as V, Avatar as rt, useCopy as En, WalletIcon as Qe, CheckIcon as pn, CopyIcon as gn, Heading as Ce, Button as Pe, DialogBody as wt, DialogFooter as Nt, Loader as In, Chip as Cn, FullScreenDialog as wn } from "@babylonlabs-io/core-ui";
import { twMerge as Z } from "tailwind-merge";
function Nn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Tt = { exports: {} }, B = Tt.exports = {}, Y, $;
function je() {
  throw new Error("setTimeout has not been defined");
}
function ze() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Y = setTimeout : Y = je;
  } catch {
    Y = je;
  }
  try {
    typeof clearTimeout == "function" ? $ = clearTimeout : $ = ze;
  } catch {
    $ = ze;
  }
})();
function At(t) {
  if (Y === setTimeout)
    return setTimeout(t, 0);
  if ((Y === je || !Y) && setTimeout)
    return Y = setTimeout, setTimeout(t, 0);
  try {
    return Y(t, 0);
  } catch {
    try {
      return Y.call(null, t, 0);
    } catch {
      return Y.call(this, t, 0);
    }
  }
}
function Tn(t) {
  if ($ === clearTimeout)
    return clearTimeout(t);
  if (($ === ze || !$) && clearTimeout)
    return $ = clearTimeout, clearTimeout(t);
  try {
    return $(t);
  } catch {
    try {
      return $.call(null, t);
    } catch {
      return $.call(this, t);
    }
  }
}
var J = [], fe = !1, re, xe = -1;
function An() {
  !fe || !re || (fe = !1, re.length ? J = re.concat(J) : xe = -1, J.length && yt());
}
function yt() {
  if (!fe) {
    var t = At(An);
    fe = !0;
    for (var e = J.length; e; ) {
      for (re = J, J = []; ++xe < e; )
        re && re[xe].run();
      xe = -1, e = J.length;
    }
    re = null, fe = !1, Tn(t);
  }
}
B.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
  J.push(new _t(t, e)), J.length === 1 && !fe && At(yt);
};
function _t(t, e) {
  this.fun = t, this.array = e;
}
_t.prototype.run = function() {
  this.fun.apply(null, this.array);
};
B.title = "browser";
B.browser = !0;
B.env = {};
B.argv = [];
B.version = "";
B.versions = {};
function ee() {
}
B.on = ee;
B.addListener = ee;
B.once = ee;
B.off = ee;
B.removeListener = ee;
B.removeAllListeners = ee;
B.emit = ee;
B.prependListener = ee;
B.prependOnceListener = ee;
B.listeners = function(t) {
  return [];
};
B.binding = function(t) {
  throw new Error("process.binding is not supported");
};
B.cwd = function() {
  return "/";
};
B.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
B.umask = function() {
  return 0;
};
var yn = Tt.exports;
const _n = /* @__PURE__ */ Nn(yn), vt = ["accountChanged", "accountsChanged"];
function ar(t) {
  return vt.includes(t);
}
const Rt = "networkChanged", vn = "chainChanged", St = "disconnect";
function dr(t, e) {
  if (typeof t.on != "function") return !1;
  try {
    t.on("accountsChanged", e);
  } catch {
    return !1;
  }
  return [...vt.filter((i) => i !== "accountsChanged"), Rt, vn, St].forEach((i) => {
    var r;
    try {
      (r = t.on) == null || r.call(t, i, e);
    } catch {
    }
  }), !0;
}
const Ve = "babylon-wallet#modal-open", lr = [
  "keplr_keystorechange",
  "leap_keystorechange",
  "okx_keystorechange"
];
function ur(t, e, n) {
  typeof t.removeListener == "function" ? t.removeListener(e, n) : typeof t.off == "function" && t.off(e, n);
}
const fr = 3600 * 1e3;
class Me {
  constructor({
    id: e,
    origin: n,
    name: i,
    icon: r,
    iconBackground: o,
    docs: s,
    networks: c,
    provider: d,
    label: h,
    hardware: m,
    connectGuide: a
  }) {
    L(this, "id");
    L(this, "origin");
    L(this, "name");
    L(this, "icon");
    L(this, "iconBackground");
    L(this, "docs");
    L(this, "networks");
    L(this, "provider", null);
    L(this, "hardware");
    L(this, "connectGuide");
    L(this, "_label");
    L(this, "account", null);
    this.id = e, this.origin = n, this.name = i, this.icon = r, this.iconBackground = o, this.docs = s, this.networks = c, this.provider = d, this._label = h, this.hardware = m ?? !1, this.connectGuide = a;
  }
  get installed() {
    return !!this.provider;
  }
  get label() {
    return this._label ?? (this.installed ? "Installed" : "");
  }
  async connect(e) {
    if (!this.provider)
      throw Error("Provider not found");
    await this.provider.connectWallet(e);
    const [n, i] = await Promise.all([this.provider.getAddress(), this.provider.getPublicKeyHex()]);
    return this.account = { address: n, publicKeyHex: i }, this;
  }
  clone() {
    return new Me({
      id: this.id,
      origin: this.origin,
      name: this.name,
      icon: this.icon,
      iconBackground: this.iconBackground,
      docs: this.docs,
      networks: this.networks,
      provider: this.provider
    });
  }
}
let Rn = () => ({
  emit(t, ...e) {
    for (let n = this.events[t] || [], i = 0, r = n.length; i < r; i++)
      n[i](...e);
  },
  events: {},
  on(t, e) {
    var n;
    return ((n = this.events)[t] || (n[t] = [])).push(e), () => {
      var i;
      this.events[t] = (i = this.events[t]) == null ? void 0 : i.filter((r) => e !== r);
    };
  }
});
const oe = {
  // ===== General/Common Errors =====
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  // Fallback
  INVALID_PARAMS: "INVALID_PARAMS",
  // Validation error
  CONNECTION_FAILED: "CONNECTION_FAILED",
  // Connection error
  METHOD_NOT_IMPLEMENTED: "METHOD_NOT_IMPLEMENTED",
  // Unimplemented feature
  MAX_ITERATION_EXCEEDED: "MAX_ITERATION_EXCEEDED",
  // Exceeded allowed iterations
  // ===== Wallet Extension/Provider =====
  EXTENSION_NOT_FOUND: "EXTENSION_NOT_FOUND",
  // Extension missing
  EXTENSION_CONTEXT_INVALIDATED: "EXTENSION_CONTEXT_INVALIDATED",
  // Context invalidated
  CONNECTION_REJECTED: "CONNECTION_REJECTED",
  // User rejected
  CONNECTION_CANCELED: "CONNECTION_CANCELED",
  // User canceled
  CHAIN_ID_NOT_INITIALIZED: "CHAIN_ID_NOT_INITIALIZED",
  // Chain ID missing
  RPC_URL_NOT_INITIALIZED: "RPC_URL_NOT_INITIALIZED",
  // RPC URL missing
  FAILED_TO_ADD_CHAIN: "FAILED_TO_ADD_CHAIN",
  // Add chain failed
  FAILED_TO_GET_KEY: "FAILED_TO_GET_KEY",
  // Key fetch failed
  WALLET_INITIALIZATION_FAILED: "WALLET_INITIALIZATION_FAILED",
  // Wallet initialization failed
  WALLET_NOT_CONNECTED: "WALLET_NOT_CONNECTED",
  // Not connected
  INCOMPATIBLE_WALLET_VERSION: "INCOMPATIBLE_WALLET_VERSION",
  // Version mismatch
  WALLET_METHOD_NOT_SUPPORTED: "WALLET_METHOD_NOT_SUPPORTED",
  // Wallet does not implement a required method
  WALLET_ACCOUNT_NOT_SUPPORTED: "WALLET_ACCOUNT_NOT_SUPPORTED",
  // Selected wallet account cannot do the action
  WALLET_ACCOUNT_CHANGED: "WALLET_ACCOUNT_CHANGED",
  // Selected wallet account or network changed while a call was in flight
  NETWORK_NOT_ENABLED_IN_WALLET: "NETWORK_NOT_ENABLED_IN_WALLET",
  // Network not enabled
  WALLET_CONFIG_REQUIRED: "WALLET_CONFIG_REQUIRED",
  // Wallet configuration required
  SHARED_SESSION_DISCONNECT_REFUSED: "SHARED_SESSION_DISCONNECT_REFUSED",
  // Disconnecting one chain would also disconnect another
  // ===== Bitcoin/PSBT/Address =====
  INVALID_PUBLIC_KEY: "INVALID_PUBLIC_KEY",
  // Invalid public key
  ADDRESS_GENERATION_FAILED: "ADDRESS_GENERATION_FAILED",
  // Address generation failed
  UNSUPPORTED_NETWORK: "UNSUPPORTED_NETWORK",
  // Network unsupported
  INVALID_ADDRESS_PREFIX: "INVALID_ADDRESS_PREFIX",
  // Address prefix invalid
  MISSING_PSBT_HEX: "MISSING_PSBT_HEX",
  // PSBT hex missing
  PSBT_HEX_REQUIRED: "PSBT_HEX_REQUIRED",
  // PSBT hex required
  PSBTS_HEXES_REQUIRED: "PSBTS_HEXES_REQUIRED",
  // Multiple PSBT hexes required
  SIGNATURE_EXTRACT_ERROR: "SIGNATURE_EXTRACT_ERROR",
  // Signature extraction failed
  GENERATION_ERROR: "GENERATION_ERROR",
  // General generation error
  ADDRESS_NOT_FOUND: "ADDRESS_NOT_FOUND",
  // Address not found
  PUBLIC_KEY_NOT_FOUND: "PUBLIC_KEY_NOT_FOUND",
  // Public key not found
  EMPTY_WITNESS_STACK: "EMPTY_WITNESS_STACK",
  // Witness stack is empty
  // ===== QR/Hardware Wallet =====
  QR_READ_ERROR: "QR_READ_ERROR",
  // QR read failed
  QR_SCAN_ERROR: "QR_SCAN_ERROR",
  // QR scan failed
  DEVICE_CEREMONY_INVALID: "DEVICE_CEREMONY_INVALID",
  // Device ceremony state unusable — restart from derivation
  DEVICE_LOCKED: "DEVICE_LOCKED",
  // Hardware device is PIN-locked
  DEVICE_WRONG_APP: "DEVICE_WRONG_APP",
  // Wrong app open on the hardware device
  DEVICE_DISCONNECTED: "DEVICE_DISCONNECTED",
  // Hardware device session lost — reconnect from a user gesture
  // ===== Inscriptions/Network =====
  INSCRIPTIONS_UNSUPPORTED_NETWORK: "INSCRIPTIONS_UNSUPPORTED_NETWORK",
  // Inscriptions unsupported
  INSCRIPTION_FETCH_ERROR: "INSCRIPTION_FETCH_ERROR"
  // Inscription fetch failed
};
class we extends Error {
  constructor({ code: n, message: i, wallet: r, version: o, chainId: s }, c) {
    super(i, c);
    L(this, "code");
    L(this, "wallet");
    L(this, "version");
    L(this, "chainId");
    this.code = n, this.wallet = r, this.version = o, this.chainId = s;
  }
}
function hr(t) {
  if (!t) return !1;
  const e = t.toLowerCase();
  return e.includes("user rejected") || e.includes("user denied") || e.includes("user cancelled") || e.includes("user canceled");
}
function Fe(t) {
  return t instanceof we && t.code === oe.SHARED_SESSION_DISCONNECT_REFUSED;
}
class Je {
  constructor(e, n, i, r, o) {
    L(this, "_connectedWallet", null);
    L(this, "_connectionGeneration", 0);
    L(this, "_ee", Rn());
    this.id = e, this.name = n, this.icon = i, this.wallets = r, this.config = o;
  }
  get connectedWallet() {
    return this._connectedWallet;
  }
  async connect(e) {
    try {
      const n = typeof e == "string" ? this.wallets.find((r) => r.id === e) : e;
      if (!n)
        throw new we({
          code: oe.EXTENSION_NOT_FOUND,
          message: "Wallet not found"
        });
      this._ee.emit("connecting", `Connecting ${n.name}`);
      const i = (r, o) => this._ee.emit("connecting", r, o);
      return await n.connect(i), this._connectedWallet = n, this._connectionGeneration += 1, this._ee.emit("connect", this._connectedWallet), this.connectedWallet;
    } catch (n) {
      return this._ee.emit("error", n), null;
    }
  }
  async disconnect(e = "chain") {
    const n = this._connectedWallet, i = this._connectionGeneration;
    if (!n) return;
    const r = n.provider;
    if (r != null && r.disconnect)
      try {
        await r.disconnect(e);
      } catch (o) {
        if (e === "chain" && Fe(o) || (this._ee.emit("error", o instanceof Error ? o : new Error(String(o))), e === "chain")) throw o;
      }
    this._connectedWallet !== n || this._connectionGeneration !== i || (this._connectedWallet = null, this._ee.emit("disconnect", n));
  }
  clone() {
    return new Je(this.id, this.name, this.icon, this.wallets, this.config);
  }
  on(e, n) {
    return this._ee.on(e, n);
  }
}
var Q = /* @__PURE__ */ ((t) => (t.MAINNET = "mainnet", t.TESTNET = "testnet", t.SIGNET = "signet", t))(Q || {});
const Sn = (t) => (e) => e[t], Ln = async ({ metadata: t, context: e, config: n }) => {
  const {
    id: i,
    wallet: r,
    name: o,
    icon: s,
    iconBackground: c,
    docs: d = "",
    networks: h = [],
    createProvider: m,
    label: a,
    hardware: l,
    connectGuide: u
  } = t, f = {
    id: i,
    name: "",
    icon: "",
    iconBackground: c,
    origin: null,
    provider: null,
    docs: d,
    networks: h,
    label: a,
    hardware: l,
    connectGuide: u == null ? void 0 : u(n)
  };
  if (r) {
    const g = typeof r == "string" ? Sn(r) : r;
    f.origin = await g(e, n) ?? null, f.provider = f.origin ? m(f.origin, n) : null;
  } else
    f.origin = null, f.provider = m(null, n);
  return typeof o == "string" ? f.name = o ?? "" : f.name = f.origin ? await o(f.origin, n) : "", typeof s == "string" ? f.icon = s ?? "" : f.icon = f.origin ? await s(f.origin, n) : "", new Me(f);
}, On = ({ id: t, name: e, icon: n, provider: i }) => new Me({
  id: t,
  origin: null,
  name: e,
  icon: n,
  docs: "",
  networks: [Q.MAINNET, Q.SIGNET],
  provider: i
}), Lt = async ({
  persistent: t,
  metadata: e,
  context: n,
  config: i,
  accountStorage: r,
  disabledWallets: o
}) => {
  const s = [], c = t ? r.get(e.chain) : void 0;
  for (const l of e.wallets)
    o != null && o.includes(l.id) || s.push(
      await Ln({
        metadata: l,
        context: n,
        config: i
      })
    );
  const d = s.find((l) => l.id === "injectable" && l.installed), h = s.filter(
    (l) => l.name.toLowerCase() !== (d == null ? void 0 : d.name.toLowerCase()) || l.id === "injectable"
  ), m = new Je(e.chain, e.name, e.icon, h, i);
  return e.chain !== "ETH" && c && s.some((l) => l.id === c && l.installed) && m.connect(c).catch((l) => {
    console.error("Auto-reconnect failed:", l instanceof Error ? l.message : "Unknown error");
  }), m;
};
function Dn({
  connectors: t,
  storage: e,
  allowReconnect: n,
  persistent: i,
  eligibleChainIds: r
}) {
  if (!n || !i) return [];
  const o = [];
  for (const s of t) {
    if (!r.has(s.id) || s.connectedWallet) continue;
    const c = e.get(s.id);
    c && s.wallets.some((d) => d.id === c && d.installed) && o.push({ connector: s, walletId: c });
  }
  return o;
}
const ot = "unisat#initialized", bn = 3e3;
function xn({
  connectors: t,
  setConnectors: e,
  config: n,
  context: i,
  storage: r,
  disabledWallets: o,
  persistent: s,
  metadata: c
}) {
  const d = M(t);
  d.current = t;
  const h = Object.values(t).some(Boolean);
  F(() => {
    if (!h) return;
    let m = !1, a = !1;
    const l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), f = async (C) => {
      if (!(m || a)) {
        m = !0;
        try {
          await g(C);
        } finally {
          m = !1;
        }
      }
    }, g = async (C) => {
      const P = Object.values(d.current).filter(Boolean).filter(
        (R) => !!c[R.id] && !R.connectedWallet && R.wallets.some((K) => K.id !== "injectable" && !K.installed)
      );
      let H = [];
      if (P.length > 0) {
        const R = await Promise.all(
          P.map(
            (b) => {
              var w;
              return Lt({
                // `persistent: false` — this rebuild only re-detects providers; the
                // stored-session reconnect is done explicitly in step 2 so it can
                // also cover connectors an earlier detect-only pass already swapped in.
                persistent: !1,
                metadata: c[b.id],
                context: i,
                config: (w = n.find((A) => A.chain === b.id)) == null ? void 0 : w.config,
                accountStorage: r,
                disabledWallets: o
              }).catch(() => null);
            }
          )
        );
        if (a) return;
        const K = R.filter((b) => {
          if (!b) return !1;
          const w = d.current[b.id];
          if (!w || w.connectedWallet) return !1;
          const A = new Set(w.wallets.filter((T) => T.installed).map((T) => T.id));
          return b.wallets.some((T) => T.installed && !A.has(T.id));
        });
        for (const b of K) u.add(b.id);
        const G = d.current;
        H = K.filter((b) => {
          var w;
          return !((w = G[b.id]) != null && w.connectedWallet);
        }), H.length > 0 && e((b) => {
          var A;
          const w = {};
          for (const T of H)
            (A = b[T.id]) != null && A.connectedWallet || (w[T.id] = T);
          return Object.keys(w).length > 0 ? { ...b, ...w } : b;
        });
      }
      if (!C || !s || u.size === 0) return;
      const D = {};
      for (const R of Object.values(d.current))
        R && (D[R.id] = R);
      for (const R of H) D[R.id] = R;
      const S = Dn({
        connectors: Object.values(D),
        storage: r,
        allowReconnect: C,
        persistent: s,
        eligibleChainIds: u
      });
      for (const { connector: R, walletId: K } of S)
        l.has(R.id) || (l.add(R.id), R.connect(K).then((G) => {
          l.delete(R.id), G && u.delete(R.id);
        }).catch(() => l.delete(R.id)));
    }, N = () => void f(!0), p = () => void f(!1), I = setTimeout(N, bn), y = typeof window < "u";
    return y && (window.addEventListener(ot, N, { once: !0 }), window.addEventListener(Ve, p)), () => {
      a = !0, clearTimeout(I), y && (window.removeEventListener(ot, N), window.removeEventListener(Ve, p));
    };
  }, [h, n, i, r, o, e, s, c]);
}
function Pn(t, e, n) {
  function i() {
    const s = n;
    if (typeof e > "u")
      return s;
    const c = e.getItem(t);
    return (c ? JSON.parse(c) : null) ?? s;
  }
  const [r, o] = le(i);
  return F(
    function() {
      e.setItem(t, JSON.stringify(r ?? ""));
    },
    [t, e, r]
  ), [r, o];
}
const Ot = ge({ lockInscriptions: !0 });
function Wn({ children: t, context: e }) {
  const [n, i] = Pn(
    "bwc-inscription-modal-lock",
    e.localStorage,
    !0
  ), r = j(
    () => ({
      lockInscriptions: n,
      toggleLockInscriptions: i
    }),
    [n, i]
  );
  return /* @__PURE__ */ E(Ot.Provider, { value: r, children: t });
}
const mr = () => Ie(Ot), X = "__babylon-wallet-confirmation-v1__", Dt = 2, Bn = {
  BTC: ["accountsChanged", Rt, St],
  BBN: ["accountChanged"],
  ETH: ["accountsChanged", "chainChanged"]
};
function Ne(t, e) {
  return t[e];
}
function Ke(t, e, n) {
  var o;
  const i = (o = Ne(t, e)) == null ? void 0 : o.config, r = (n == null ? void 0 : n[e]) ?? (e === "BTC" ? i == null ? void 0 : i.network : i == null ? void 0 : i.chainId);
  return r === void 0 ? "" : String(r);
}
function ce(t, e) {
  return t.toLowerCase() === e.toLowerCase();
}
function Hn(t) {
  if (!t || typeof t != "object" || Array.isArray(t)) return !1;
  const e = t;
  return typeof e.chain == "string" && typeof e.walletId == "string" && typeof e.address == "string" && typeof e.publicKeyHex == "string" && typeof e.network == "string";
}
function Te(t) {
  if (t)
    try {
      const e = JSON.parse(t);
      return (e == null ? void 0 : e.version) !== Dt || !Array.isArray(e.entries) || !e.entries.every(Hn) ? void 0 : e;
    } catch {
      return;
    }
}
function Ee(t, e, n) {
  const i = t.filter((r) => r.account && Ne(e, r.chain)).map((r) => ({
    chain: r.chain,
    walletId: r.wallet.id,
    address: r.account.address,
    publicKeyHex: r.account.publicKeyHex,
    network: Ke(e, r.chain, n)
  })).sort((r, o) => r.chain.localeCompare(o.chain));
  return JSON.stringify({ version: Dt, entries: i });
}
function Mn(t, e, n) {
  var r;
  const i = (r = Te(t)) == null ? void 0 : r.entries;
  return i ? e.every((o) => {
    var m;
    const s = o, c = (m = Ne(n, s)) == null ? void 0 : m.connectedWallet, d = c == null ? void 0 : c.account, h = i.find((a) => a.chain === s);
    return !!(c && d && h && h.walletId === c.id && ce(h.address, d.address) && ce(h.publicKeyHex, d.publicKeyHex) && h.network === Ke(n, s));
  }) : !1;
}
function Fn(t, e, n) {
  var r;
  const i = (r = Te(t)) == null ? void 0 : r.entries;
  return i ? e.every((o) => {
    var h;
    const s = o, c = (h = Ne(n, s)) == null ? void 0 : h.connectedWallet, d = i.find((m) => m.chain === s);
    return !!(c && d && d.walletId === c.id && d.network === Ke(n, s));
  }) : !1;
}
async function Kn(t, e, n) {
  var o;
  const i = (o = Te(t)) == null ? void 0 : o.entries;
  return i ? (await Promise.all(
    e.map(async (s) => {
      var l, u;
      const c = s, d = Ne(n, c), h = d == null ? void 0 : d.connectedWallet, m = h == null ? void 0 : h.provider, a = i.find((f) => f.chain === c);
      if (!h || !m || !a || a.walletId !== h.id) return !1;
      try {
        if (((l = m.isIdentityCurrent) == null ? void 0 : l.call(m)) === !1) return !1;
        const [f, g, N] = await Promise.all([
          m.getAddress(),
          m.getPublicKeyHex(),
          c === "ETH" ? m.getChainId() : c === "BTC" ? m.getNetwork() : Ke(n, c)
        ]);
        return ((u = m.isIdentityCurrent) == null ? void 0 : u.call(m)) === !1 ? !1 : ce(a.address, f) && ce(a.publicKeyHex, g) && a.network === String(N);
      } catch {
        return !1;
      }
    })
  )).every(Boolean) : !1;
}
function bt(t, e, n, i) {
  var s;
  const r = (s = Te(t)) == null ? void 0 : s.entries;
  if (!r) return () => {
  };
  const o = [];
  return e.forEach((c) => {
    var m, a, l;
    const d = c, h = (a = (m = n[d]) == null ? void 0 : m.connectedWallet) == null ? void 0 : a.provider;
    h != null && h.on && ((l = Bn[d]) == null || l.forEach((u) => {
      var g;
      const f = (...N) => {
        const p = N[0], I = r.find((y) => y.chain === d);
        d === "ETH" && u === "accountsChanged" && Array.isArray(p) && p.length === 1 && typeof p[0] == "string" && I && ce(I.address, p[0]) || i(d);
      };
      try {
        (g = h.on) == null || g.call(h, u, f), o.push({ event: u, handler: f, provider: h });
      } catch {
      }
    }));
  }), () => {
    o.forEach(({ event: c, handler: d, provider: h }) => {
      var m;
      try {
        (m = h.off) == null || m.call(h, c, d);
      } catch {
      }
    });
  };
}
function xt(t) {
  var e;
  return ((e = Te(t)) == null ? void 0 : e.entries.map((n) => n.chain)) ?? [];
}
const Ye = {
  confirmed: !1,
  visible: !1,
  screen: { type: "CHAINS" },
  chains: {},
  selectedWallets: {},
  requiredChainIds: []
}, Pt = ge(Ye);
function Un(t, e) {
  return Object.keys(t).reduce((n, i) => (e.has(i) && (n[i] = t[i]), n), {});
}
function Gn({ children: t, chains: e, requiredChainIds: n, storage: i }) {
  const [r, o] = le(() => ({
    ...Ye,
    chains: e.reduce((a, l) => ({ ...a, [l.id]: l }), {}),
    requiredChainIds: [...n]
  })), s = n.some((a) => !r.requiredChainIds.includes(a)), c = j(
    () => ({
      ...r,
      confirmed: s ? !1 : r.confirmed,
      requiredChainIds: [...n]
    }),
    [n, s, r]
  ), d = M(n);
  mn(() => {
    d.current = n;
  }, [n]), F(() => {
    o((a) => {
      const l = e.reduce((N, p) => ({ ...N, [p.id]: p }), {}), u = new Set(e.map((N) => N.id)), f = Un(a.selectedWallets, u), g = n.some((N) => !a.requiredChainIds.includes(N));
      return {
        ...a,
        confirmed: g ? !1 : a.confirmed,
        chains: l,
        selectedWallets: f,
        requiredChainIds: [...n]
      };
    });
  }, [e, n]);
  const h = j(
    () => ({
      open: () => {
        typeof window < "u" && window.dispatchEvent(new Event(Ve)), o((a) => ({ ...a, visible: !0 }));
      },
      close: () => {
        o((a) => ({ ...a, visible: !1 }));
      },
      reset: () => {
        i == null || i.delete(X), o(({ chains: a, requiredChainIds: l }) => ({ ...Ye, chains: a, requiredChainIds: l }));
      },
      displayLoader: (a = "", l = "") => {
        o((u) => ({ ...u, screen: { type: "LOADER", params: { message: a, description: l } } }));
      },
      displayChains: () => {
        o((a) => ({ ...a, screen: { type: "CHAINS" } }));
      },
      displayWallets: (a) => {
        o((l) => ({ ...l, screen: { type: "WALLETS", params: { chain: a } } }));
      },
      displayConnectGuide: (a, l) => {
        o((u) => ({ ...u, screen: { type: "CONNECT_GUIDE", params: { chain: a, wallet: l } } }));
      },
      displayError: (a) => {
        o((l) => ({ ...l, screen: { type: "ERROR", params: a } }));
      },
      selectWallet: (a, l) => {
        o((u) => ({
          ...u,
          selectedWallets: { ...u.selectedWallets, [a]: l }
        }));
      },
      removeWallet: (a) => {
        const l = d.current.includes(a);
        l && (i == null || i.delete(X)), o((u) => ({
          ...u,
          // Losing an optional chain must not tear down a confirmed session.
          // Losing a required one does invalidate the confirmation, so
          // reconnecting cannot silently restore it.
          confirmed: l ? !1 : u.confirmed,
          confirmationReceipt: l ? void 0 : u.confirmationReceipt,
          selectedWallets: { ...u.selectedWallets, [a]: void 0 }
        }));
      },
      confirm: (a) => {
        o((l) => ({ ...l, confirmed: !0, confirmationReceipt: a }));
      },
      unconfirm: (a = !1) => {
        o((l) => ({
          ...l,
          confirmed: !1,
          confirmationReceipt: a ? l.confirmationReceipt : void 0
        }));
      }
    }),
    [i]
  ), m = j(
    () => ({
      ...c,
      ...h
    }),
    [c, h]
  );
  return /* @__PURE__ */ E(Pt.Provider, { value: m, children: t });
}
const $e = {
  BTC: null,
  BBN: null,
  ETH: null
}, Wt = ge($e);
function Er({
  persistent: t,
  storage: e,
  children: n,
  context: i,
  config: r,
  onError: o,
  disabledWallets: s,
  requiredChains: c,
  metadata: d
}) {
  const [h, m] = le($e), a = U(async () => {
    const g = r.filter((p) => d[p.chain]).map(async ({ chain: p, config: I }) => {
      const y = d[p];
      if (!y) return null;
      try {
        return await Lt({
          persistent: t,
          metadata: y,
          context: i,
          config: I,
          accountStorage: e,
          disabledWallets: s
        });
      } catch (C) {
        throw console.error("[ChainProvider] failed to create connector for chain:", p, C instanceof Error ? C.message : "Unknown error"), C;
      }
    });
    return (await Promise.all(g)).reduce(
      (p, I) => I ? { ...p, [I.id]: I } : p,
      { ...$e }
    );
  }, [t, r, i, e, s, d]);
  F(() => {
    a().then((f) => {
      m(f);
    }).catch((f) => {
      console.error("[ChainProvider] init failed with error:", f instanceof Error ? f.message : "Unknown error"), o == null || o(f);
    });
  }, [m, a, o]), xn({ connectors: h, setConnectors: m, config: r, context: i, storage: e, disabledWallets: s, persistent: t, metadata: d }), F(() => {
    const f = Object.values(h).filter(Boolean);
    if (f.length === 0) return;
    const g = () => m((p) => ({ ...p })), N = f.flatMap((p) => [p.on("connect", g), p.on("disconnect", g)]);
    return () => N.forEach((p) => p());
  }, [h]);
  const l = j(
    () => Object.values(h).filter((f) => !!f),
    [h]
  ), u = j(
    () => c === void 0 ? r.filter((f) => d[f.chain]).map((f) => f.chain) : [...c],
    [r, d, c]
  );
  return /* @__PURE__ */ E(Wn, { context: i, children: /* @__PURE__ */ E(Gn, { chains: l, requiredChainIds: u, storage: e, children: /* @__PURE__ */ E(Wt.Provider, { value: h, children: n }) }) });
}
const Ae = () => Ie(Wt), Bt = ge({});
function pr({ children: t, value: e }) {
  const n = j(() => e ?? {}, [e]);
  return /* @__PURE__ */ E(Bt.Provider, { value: n, children: t });
}
const Ht = () => Ie(Bt), pe = "baby-connected-wallet-accounts";
function De(t, e) {
  const n = e == null ? void 0 : e[t];
  return n ? `${t}:${n}` : t;
}
function be() {
  const t = localStorage.getItem(pe);
  if (!t) return {};
  try {
    const e = JSON.parse(t);
    return !e || typeof e != "object" || Array.isArray(e) ? (localStorage.removeItem(pe), {}) : e;
  } catch (e) {
    return console.error("[account-storage] Failed to parse accounts map, clearing corrupted entry:", e), localStorage.removeItem(pe), {};
  }
}
function ct(t) {
  try {
    localStorage.setItem(pe, JSON.stringify(t));
  } catch (e) {
    console.error("[account-storage] Failed to write accounts map, clearing entry:", e), localStorage.removeItem(pe);
  }
}
const gr = (t, e) => {
  function n(r) {
    const o = r._timestamps;
    return o && typeof o == "object" && !Array.isArray(o) ? o : {};
  }
  function i(r, o) {
    const c = n(r)[o];
    if (typeof c != "number" || !Number.isFinite(c)) return !0;
    const d = Date.now();
    return c < 0 || c > d + t ? !0 : d - c > t;
  }
  return {
    get: (r) => {
      const o = be(), s = De(r, e);
      if (!i(o, s))
        return o[s];
    },
    has: (r) => {
      const o = be(), s = De(r, e);
      return i(o, s) ? !1 : !!o[s];
    },
    set: (r, o) => {
      const s = be(), c = De(r, e), d = n(s);
      s[c] = o, s._timestamps = { ...d, [c]: Date.now() }, ct(s);
    },
    delete: (r) => {
      const o = be(), s = De(r, e), c = n(o), d = Reflect.deleteProperty(o, s);
      return delete c[s], o._timestamps = c, ct(o), d;
    }
  };
}, kn = "#000000", Ir = "#1FE121", jn = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='225px'%20height='224px'%20viewBox='0%200%20225%20224'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eokx%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20strokeWidth='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='okx'%20transform='translate(0.401000,%200.006000)'%20fill='%23FFFFFF'%20fill-rule='nonzero'%3e%3cpath%20d='M144.382,74.667%20L79.673,74.667%20C76.924,74.667%2074.695,76.895%2074.695,79.644%20L74.695,144.354%20C74.695,147.103%2076.924,149.332%2079.673,149.332%20L144.382,149.332%20C147.131,149.332%20149.36,147.103%20149.36,144.354%20L149.36,79.644%20C149.36,76.895%20147.131,74.667%20144.382,74.667%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,0%20L4.978,0%20C2.229,0%200,2.228%200,4.978%20L0,69.687%20C0,72.436%202.229,74.665%204.978,74.665%20L69.687,74.665%20C72.437,74.665%2074.665,72.436%2074.665,69.687%20L74.665,4.978%20C74.665,2.228%2072.437,0%2069.687,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,0%20L154.307,0%20C151.558,0%20149.329,2.228%20149.329,4.978%20L149.329,69.687%20C149.329,72.436%20151.558,74.665%20154.307,74.665%20L219.017,74.665%20C221.766,74.665%20223.994,72.436%20223.994,69.687%20L223.994,4.978%20C223.994,2.228%20221.766,0%20219.017,0%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M69.687,149.328%20L4.978,149.328%20C2.229,149.328%200,151.556%200,154.305%20L0,219.015%20C0,221.764%202.229,223.993%204.978,223.993%20L69.687,223.993%20C72.437,223.993%2074.665,221.764%2074.665,219.015%20L74.665,154.305%20C74.665,151.556%2072.437,149.328%2069.687,149.328%20Z'%20id='Path'%3e%3c/path%3e%3cpath%20d='M219.017,149.328%20L154.307,149.328%20C151.558,149.328%20149.329,151.556%20149.329,154.305%20L149.329,219.015%20C149.329,221.764%20151.558,223.993%20154.307,223.993%20L219.017,223.993%20C221.766,223.993%20223.994,221.764%20223.994,219.015%20L223.994,154.305%20C223.994,151.556%20221.766,149.328%20219.017,149.328%20Z'%20id='Path'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", We = "babylon:open-appkit", Mt = "appkit-eth-connector", zn = "appkit-btc-connector", st = "bigint", at = "function", Vn = "AppKit configuration cannot be serialized.", Yn = 1, dt = /* @__PURE__ */ new WeakMap();
let $n = Yn;
function Xn(t) {
  const e = dt.get(t);
  if (e) return e;
  const n = $n++;
  return dt.set(t, n), n;
}
function lt(t) {
  const e = JSON.stringify(t, (n, i) => typeof i === st ? { type: st, value: i.toString() } : typeof i === at ? { type: at, value: Xn(i) } : i && typeof i == "object" && !Array.isArray(i) ? Object.fromEntries(
    Object.entries(i).sort(([r], [o]) => r < o ? -1 : r > o ? 1 : 0)
  ) : i);
  if (e === void 0)
    throw new TypeError(Vn);
  return e;
}
function Zn({
  projectId: t,
  metadata: e,
  ethChain: n,
  btcNetwork: i
}) {
  return Object.freeze({
    projectId: t,
    metadataFingerprint: lt(e),
    ethFingerprint: n ? lt(n) : void 0,
    btcNetwork: i
  });
}
let q = null, Ft = null;
const Be = /* @__PURE__ */ new Set();
function k(t, e) {
  throw new we({ code: oe.WALLET_INITIALIZATION_FAILED, message: t, chainId: e });
}
function qe() {
  return q;
}
function He() {
  return (q == null ? void 0 : q.modal) ?? Ft;
}
function Qn(t, e) {
  q && k(
    `Cannot set a manual ${t} AppKit configuration after AppKit initialization. Use the canonical AppKit state.`
  ), Be.add(t), e && (Ft = e);
}
function Jn(t) {
  return t ? (Be.size > 0 && k(
    `Cannot initialize AppKit after a manual ${[...Be].join(" and ")} configuration was set. Use only one initialization method.`
  ), !0) : (q && k(
    "AppKit is already initialized. A project ID is required to validate the requested configuration."
  ), !1);
}
function qn(t) {
  return q && k("AppKit is already initialized. Reuse the shared AppKit state instead of replacing it."), Be.size > 0 && k("Cannot publish AppKit state after a manual shared configuration was set."), q = Object.freeze({
    ...t,
    btcConfig: t.btcConfig ? Object.freeze({ ...t.btcConfig }) : void 0
  }), q;
}
function ei(t, e) {
  t.projectId !== e.projectId && k(
    "AppKit was already initialized with a different project ID. A page can use only one AppKit configuration."
  ), t.metadataFingerprint !== e.metadataFingerprint && k(
    "AppKit was already initialized with different metadata. A page can use only one AppKit configuration."
  ), e.ethFingerprint && (t.ethFingerprint || k(
    "AppKit was already initialized without Ethereum support. A page that needs Ethereum must initialize AppKit with Ethereum first.",
    "ETH"
  ), t.ethFingerprint !== e.ethFingerprint && k("AppKit was already initialized with a different Ethereum chain configuration.", "ETH")), e.btcNetwork && (t.btcNetwork || k(
    "AppKit was already initialized without Bitcoin support. A page that needs Bitcoin must initialize AppKit with Bitcoin first.",
    "BTC"
  ), t.btcNetwork !== e.btcNetwork && k("AppKit was already initialized with a different Bitcoin network.", "BTC"));
}
function ut(t, e) {
  if (typeof document > "u") {
    const d = setTimeout(t, e);
    return () => clearTimeout(d);
  }
  let n = e, i = 0, r;
  const o = () => {
    i = Date.now(), r = setTimeout(() => {
      document.removeEventListener("visibilitychange", c), t();
    }, n);
  }, s = () => {
    clearTimeout(r), r = void 0, n = Math.max(0, n - (Date.now() - i));
  }, c = () => {
    document.visibilityState === "hidden" ? r !== void 0 && s() : r === void 0 && o();
  };
  return document.addEventListener("visibilitychange", c), document.visibilityState !== "hidden" && o(), () => {
    clearTimeout(r), document.removeEventListener("visibilitychange", c);
  };
}
const ti = "Ethereum", ni = "Shared wagmi config is being replaced. This might indicate multiple initializations.";
let he = null;
function Cr(t) {
  Qn(ti), he && he !== t && console.warn(ni), he = t;
}
function Kt() {
  const t = qe();
  if (t)
    return t.wagmiConfig || k(
      "AppKit was initialized without Ethereum support. Initialize it with Ethereum support.",
      "ETH"
    ), t.wagmiConfig;
  if (!he)
    throw new Error(
      "Shared wagmi config not initialized. Initialize AppKit with Ethereum support, or use setSharedWagmiConfig() as an exclusive manual alternative."
    );
  return he;
}
function ke() {
  const t = qe();
  return t ? t.wagmiConfig !== void 0 : he !== null;
}
function Ut() {
  var n;
  const t = He();
  return (t == null ? void 0 : t.getProviderType("eip155")) === "WALLET_CONNECT" && ((n = t == null ? void 0 : t.getAccount("bip122")) == null ? void 0 : n.isConnected) === !0;
}
const ii = 1500, ri = 6e4, oi = 3e3, ft = "Wallet not connected", ci = "Ethereum Wallet", si = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=";
function te(t) {
  return t && $t(t, { strict: !1 }) ? t : void 0;
}
class ai {
  constructor(e) {
    L(this, "config");
    L(this, "address");
    L(this, "chainId");
    L(this, "eventHandlers", /* @__PURE__ */ new Map());
    L(this, "unwatchFunctions", []);
    L(this, "emptyAccountTimer");
    this.config = e, this.ensureEventWatchers();
  }
  /**
   * Attach the wagmi watchers exactly once, and only when the shared config
   * exists. The provider is now constructed unconditionally (it no longer
   * waits on an injected `window.ethereum`), so construction must not throw
   * when AppKit init has not run or has fallen back — that would take down the
   * BTC connector alongside the ETH one. `connectWallet` re-checks and still
   * surfaces the actionable "AppKit ETH not initialized" error, and calling
   * this again there picks the watchers up if init landed late.
   */
  ensureEventWatchers() {
    this.unwatchFunctions.length > 0 || ke() && this.setupEventWatchers();
  }
  /**
   * Get the shared wagmi config (throws if not set)
   * This ensures we never create multiple wagmi instances
   */
  getWagmiConfig() {
    if (!ke())
      throw new Error(
        "AppKit ETH not initialized. Ensure AppKit modal is initialized at application startup by calling initializeAppKitModal() with eth config in your app's entry point."
      );
    return Kt();
  }
  setupEventWatchers() {
    const e = this.getWagmiConfig(), n = ie(e), i = te(n.address);
    i && n.status === "connected" && (this.address = i, this.chainId = n.chainId, setTimeout(() => {
      this.emit("accountsChanged", [i]);
    }, 100));
    const r = it(e, {
      onChange: (s) => {
        const c = this.address, d = te(s.address);
        if (!d) {
          if (!c) {
            this.chainId = s.chainId;
            return;
          }
          if (this.emptyAccountTimer !== void 0) return;
          this.emptyAccountTimer = setTimeout(() => {
            this.emptyAccountTimer = void 0, this.address = void 0, this.chainId = void 0, this.emit("accountsChanged", []);
          }, oi);
          return;
        }
        this.clearEmptyAccountTimer(), this.address = d, this.chainId = s.chainId, (c == null ? void 0 : c.toLowerCase()) !== d.toLowerCase() && this.emit("accountsChanged", [d]);
      }
    }), o = Zt(e, {
      onChange: (s) => {
        const c = this.chainId;
        this.chainId = s, c !== s && this.emit("chainChanged", `0x${s.toString(16)}`);
      }
    });
    this.unwatchFunctions.push(r, o, () => this.clearEmptyAccountTimer());
  }
  clearEmptyAccountTimer() {
    clearTimeout(this.emptyAccountTimer), this.emptyAccountTimer = void 0;
  }
  emit(e, n) {
    const i = this.eventHandlers.get(e);
    i && i.forEach((r) => r(n));
  }
  async connectWallet() {
    try {
      const e = this.getWagmiConfig();
      this.ensureEventWatchers();
      const n = ie(e), i = te(n.address);
      if (i) {
        this.address = i, this.chainId = n.chainId;
        return;
      }
      if (typeof window < "u") {
        await new Promise((d, h) => {
          let m = !1, a;
          const l = () => {
            u(), a == null || a(), f(), N == null || N();
          }, u = ut(() => {
            l(), h(new Error("Connection timeout"));
          }, ri), f = it(e, {
            onChange: (p) => {
              const I = te(p.address);
              I && (this.address = I, this.chainId = p.chainId, l(), d());
            }
          }), g = He(), N = g == null ? void 0 : g.subscribeState((p) => {
            if (p.open)
              m = !0, a == null || a(), a = void 0;
            else if (m) {
              const I = ie(e), y = te(I.address);
              if (y) {
                this.address = y, this.chainId = I.chainId, l(), d();
                return;
              }
              if (a) return;
              a = ut(() => {
                const C = ie(e), P = te(C.address);
                P ? (this.address = P, this.chainId = C.chainId, l(), d()) : (l(), h(new Error("Connection cancelled")));
              }, ii);
            }
          });
          window.dispatchEvent(new CustomEvent(We));
        });
        return;
      }
      const r = _n.env.NEXT_PUBLIC_REOWN_PROJECT_ID;
      if (!r)
        throw new Error("NEXT_PUBLIC_REOWN_PROJECT_ID environment variable is required");
      const o = sn({
        projectId: r,
        metadata: {
          name: "Babylon Vault",
          description: "",
          url: "",
          icons: [""]
        }
      }), s = await Qt(e, { connector: o });
      this.address = te(s.accounts[0]), this.chainId = s.chainId;
    } catch (e) {
      throw console.error("Failed to connect wallet:", e instanceof Error ? e.message : "Unknown error"), new Error(`Failed to connect wallet: ${e instanceof Error ? e.message : "Unknown error"}`);
    }
  }
  async disconnect(e) {
    if (e === "chain" && Ut())
      throw new we({
        code: oe.SHARED_SESSION_DISCONNECT_REFUSED,
        message: "Ethereum and Bitcoin share one wallet session. Disconnecting Ethereum alone would also disconnect Bitcoin. Disconnect all wallets instead.",
        wallet: "AppKit",
        chainId: "ETH"
      });
    e !== "local" && await Jt(this.getWagmiConfig()), this.clearEmptyAccountTimer(), this.address = void 0, this.chainId = void 0;
  }
  async getAddress() {
    const e = this.getWagmiConfig(), n = ie(e), i = te(n.address);
    if (i)
      return this.address = i, this.chainId = n.chainId, i;
    if (this.address)
      return this.address;
    throw new Error(ft);
  }
  async getPublicKeyHex() {
    return this.getAddress();
  }
  async signMessage(e) {
    try {
      const n = this.getWagmiConfig(), i = await this.getAddress();
      return await qt(n, {
        message: e,
        account: i
      });
    } catch (n) {
      throw new Error(`Failed to sign message: ${n}`);
    }
  }
  async signTypedData(e) {
    try {
      const n = this.getWagmiConfig(), i = await this.getAddress();
      return await en(n, {
        account: i,
        domain: {
          ...e.domain,
          salt: e.domain.salt,
          verifyingContract: e.domain.verifyingContract
        },
        types: e.types,
        primaryType: e.primaryType,
        message: e.message
      });
    } catch (n) {
      throw new Error(`Failed to sign typed data: ${n}`);
    }
  }
  async sendTransaction(e) {
    try {
      const n = this.getWagmiConfig(), i = await this.getAddress();
      return await tn(n, {
        account: i,
        to: e.to,
        value: e.value ? nt(e.value) : void 0,
        data: e.data,
        gas: e.gasLimit,
        maxFeePerGas: e.maxFeePerGas,
        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
        nonce: e.nonce
      });
    } catch (n) {
      throw new Error(`Failed to send transaction: ${n}`);
    }
  }
  async estimateGas(e) {
    try {
      const n = this.getWagmiConfig(), i = await this.getAddress();
      return await nn(n, {
        account: i,
        to: e.to,
        value: e.value ? nt(e.value) : void 0,
        data: e.data
      });
    } catch (n) {
      throw new Error(`Failed to estimate gas: ${n}`);
    }
  }
  async getChainId() {
    if (this.chainId)
      return this.chainId;
    const e = this.getWagmiConfig(), n = ie(e);
    if (n.chainId)
      return this.chainId = n.chainId, this.chainId;
    throw new Error(ft);
  }
  async switchChain(e) {
    try {
      const n = this.getWagmiConfig();
      if (![1, 11155111, 31337].includes(e))
        throw new Error(`Unsupported chain ID: ${e}`);
      await rn(n, { chainId: e }), this.chainId = e;
    } catch (n) {
      throw new Error(`Failed to switch chain: ${n}`);
    }
  }
  async getBalance() {
    try {
      const e = this.getWagmiConfig(), n = await this.getAddress();
      return (await on(e, {
        address: n
      })).value;
    } catch (e) {
      throw new Error(`Failed to get balance: ${e}`);
    }
  }
  async getNonce() {
    try {
      const e = this.getWagmiConfig(), n = await this.getAddress();
      return await cn(e, {
        address: n
      });
    } catch (e) {
      throw new Error(`Failed to get nonce: ${e}`);
    }
  }
  async getNetworkInfo() {
    const e = await this.getChainId();
    return {
      name: this.config.chainName || "Ethereum",
      chainId: e.toString()
    };
  }
  /**
   * Identity of the wallet the user actually connected through AppKit
   * (e.g. MetaMask, Rainbow), read from the active wagmi connector. Falls back
   * to a generic Ethereum identity when the connector doesn't expose its own.
   */
  getActiveConnectorIdentity() {
    var n;
    const e = (n = He()) == null ? void 0 : n.getWalletInfo("eip155");
    if (e != null && e.name || e != null && e.icon)
      return { name: e.name, icon: e.icon };
    if (ke())
      try {
        const { connector: i } = ie(this.getWagmiConfig());
        return i ? { name: i.name, icon: i.icon } : void 0;
      } catch {
        return;
      }
  }
  getWalletProviderName() {
    var n;
    const e = (n = this.getActiveConnectorIdentity()) == null ? void 0 : n.name;
    return e != null && e.trim() ? e : ci;
  }
  getWalletProviderIcon() {
    var n;
    const e = (n = this.getActiveConnectorIdentity()) == null ? void 0 : n.icon;
    return e != null && e.trim() ? e : si;
  }
  on(e, n) {
    this.eventHandlers.has(e) || this.eventHandlers.set(e, /* @__PURE__ */ new Set()), this.eventHandlers.get(e).add(n);
  }
  off(e, n) {
    const i = this.eventHandlers.get(e);
    i && i.delete(n);
  }
  // Cleanup method for proper resource management
  destroy() {
    this.unwatchFunctions.forEach((e) => e()), this.eventHandlers.clear();
  }
}
const di = "AppKit", li = {
  id: Mt,
  name: di,
  icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=",
  docs: "https://docs.reown.com/appkit/overview",
  // No `wallet` global: AppKit reaches wallets through its own EIP-6963,
  // WalletConnect and hardware transports, none of which require an injected
  // `window.ethereum`. Gating on that global made every user without an EVM
  // browser extension (Safari, WalletConnect-QR, hardware-only) fail with
  // "Provider not found" before the AppKit modal could open — and ETH is a
  // required chain for deposit. Mirrors the BTC AppKit entry.
  wallet: void 0,
  createProvider: (t, e) => new ai(e),
  networks: [
    Q.MAINNET,
    // ETH mainnet (chainId: 1)
    Q.TESTNET,
    // ETH testnet (chainId: 11155111 - Sepolia)
    Q.SIGNET
    // Also allow SIGNET/devnet/localhost environments
  ],
  label: "Connect ETH Wallet"
}, ui = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%201920%201920'%20viewBox='0%200%201920%201920'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='m959.8%2080.7-539.7%20895.6%20539.7-245.3z'%20fill='%238a92b2'/%3e%3cpath%20d='m959.8%20731-539.7%20245.3%20539.7%20319.1z'%20fill='%2362688f'/%3e%3cpath%20d='m1499.6%20976.3-539.8-895.6v650.3z'%20fill='%2362688f'/%3e%3cpath%20d='m959.8%201295.4%20539.8-319.1-539.8-245.3z'%20fill='%23454a75'/%3e%3cpath%20d='m420.1%201078.7%20539.7%20760.6v-441.7z'%20fill='%238a92b2'/%3e%3cpath%20d='m959.8%201397.6v441.7l540.1-760.6z'%20fill='%2362688f'/%3e%3c/svg%3e", wr = {
  chain: "ETH",
  name: "Ethereum",
  // icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzYyN0VFQSIvPgogIDxwYXRoIGQ9Ik0xNiA0TDcuNSAxNi4yNUwxNiAyMkwyNC41IDE2LjI1TDE2IDR6IiBmaWxsPSJ3aGl0ZSIvPgogIDxwYXRoIGQ9Ik0xNiAyMi43NUw3LjUgMTdMMTYgMjhMMjQuNSAxN0wxNiAyMi43NXoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4=",
  icon: ui,
  wallets: [li]
};
function fi(t, e) {
  const n = t.rpcUrls.default.http[0];
  return new dn({
    networks: [t],
    projectId: e,
    ssr: !1,
    storage: fn({ storage: hn }),
    connectors: [an({ preference: { telemetry: !1 } })],
    transports: {
      [t.id]: Xt(n)
    }
  });
}
function Nr(t) {
  if (!Jn(t.projectId)) return null;
  const { chain: e } = t.eth, n = Zn({
    projectId: t.projectId,
    metadata: t.metadata,
    ethChain: e
  }), i = qe();
  if (i)
    return ei(i, n), { modal: i.modal, wagmiConfig: Kt() };
  ln && k("Reown AppKit was initialized outside this package. Use only this package to initialize it.");
  const r = fi(e, t.projectId), o = un({
    adapters: [r],
    networks: [e],
    projectId: t.projectId,
    metadata: t.metadata,
    features: { email: !1, socials: !1 }
  });
  return { modal: qn({ modal: o, ...n, wagmiConfig: r.wagmiConfig }).modal, wagmiConfig: r.wagmiConfig };
}
const Tr = () => {
  F(() => {
    const t = () => {
      try {
        const e = He();
        e && e.open();
      } catch (e) {
        console.warn("AppKit modal not available:", e);
      }
    };
    return window.addEventListener(We, t), () => window.removeEventListener(We, t);
  }, []);
};
function hi(t) {
  const e = Ae();
  return (e == null ? void 0 : e[t]) ?? null;
}
const mi = [
  { match: /okx/i, icon: jn, iconBackground: kn }
];
function Ei(t) {
  return mi.find(({ match: e }) => e.test(t));
}
const se = () => Ie(Pt);
async function ht(t) {
  const e = t.provider;
  if (!(e != null && e.getWalletProviderName) || !(e != null && e.getWalletProviderIcon)) return t;
  const [n, i] = await Promise.all([e.getWalletProviderName(), e.getWalletProviderIcon()]), r = Ei(n || t.name);
  return {
    id: t.id,
    name: n || t.name,
    icon: (r == null ? void 0 : r.icon) || i || t.icon,
    iconBackground: r == null ? void 0 : r.iconBackground,
    docs: t.docs,
    installed: t.installed,
    provider: t.provider,
    account: t.account,
    label: t.label,
    hardware: t.hardware
  };
}
const pi = /* @__PURE__ */ new Map([
  [oe.INCOMPATIBLE_WALLET_VERSION, (t) => `Update ${t}`],
  [oe.DEVICE_WRONG_APP, () => "Wrong App on Device"],
  [oe.DEVICE_LOCKED, () => "Signing Device Locked"]
]);
function gi({ persistent: t, accountStorage: e, onError: n, btcValidation: i }) {
  const r = Ae(), {
    confirmed: o,
    confirmationReceipt: s,
    visible: c,
    selectWallet: d,
    removeWallet: h,
    displayLoader: m,
    displayChains: a,
    displayConnectGuide: l,
    displayError: u,
    confirm: f,
    unconfirm: g,
    requiredChainIds: N = []
  } = se(), { verifyBTCAddress: p } = Ht(), I = M(0), y = M(N), C = s ?? (t && !c ? e.get(X) : void 0), P = M(), H = M(/* @__PURE__ */ new Set()), D = N.every((w) => {
    var A;
    return (A = r[w]) == null ? void 0 : A.connectedWallet;
  }), S = M(/* @__PURE__ */ new Set()), R = async (w) => {
    S.current.add(w.id), h == null || h(w.id), t && e.delete(w.id);
    try {
      await w.disconnect("chain");
    } catch (A) {
      Fe(A) || console.error(
        "Failed to disconnect rejected wallet:",
        A instanceof Error ? A.message : "Unknown error"
      ), await w.disconnect("local");
    } finally {
      S.current.delete(w.id);
    }
  };
  F(() => {
    if (!c) return;
    const A = Object.values(r).filter(Boolean).map(
      (T) => T.on("connecting", (_, v) => {
        m == null || m(_, v);
      })
    );
    return () => A.forEach((T) => T());
  }, [c, m, r]), F(() => {
    const w = Object.values(r).filter(Boolean), A = {
      BTC: (_) => async (v) => {
        var W, ye, _e, ve;
        try {
          if (!v || !v.account) return;
          if (!i) throw new Error("Bitcoin address validation is unavailable");
          if (d == null || d("BTC", v), t && ((W = v.account) != null && W.address) && e.set(_.id, v.id), !c) return;
          i.validateAddress(_.config.network, v.account.address);
          const x = () => void (a == null ? void 0 : a());
          if (!i.validateAddressWithPK(
            ((ye = v.account) == null ? void 0 : ye.address) ?? "",
            ((_e = v.account) == null ? void 0 : _e.publicKeyHex) ?? "",
            _.config.network
          )) {
            u == null || u({
              title: "Public Key Mismatch",
              description: "The Bitcoin address and Public Key for this wallet do not match. Please contact your wallet provider for support.",
              onSubmit: x,
              onCancel: () => {
                R(_), a == null || a();
              }
            });
            return;
          }
          if (p && !await p(((ve = v.account) == null ? void 0 : ve.address) ?? "")) {
            u == null || u({
              title: "Staking Currently Unavailable",
              description: "Staking is temporarily disabled due to network downtime. New stakes are paused until the network resumes.",
              submitButton: "",
              cancelButton: "Done",
              onCancel: async () => {
                R(_), a == null || a();
              }
            });
            return;
          }
          x();
        } catch (x) {
          R(_), u == null || u({
            title: "Connection Failed",
            description: x.message,
            submitButton: "",
            cancelButton: "Done",
            onCancel: async () => {
              a == null || a();
            }
          });
        }
      },
      BBN: (_) => (v) => {
        var W;
        v && (d == null || d(_.id, v), t && ((W = v.account) != null && W.address) && e.set(_.id, v.id)), a == null || a();
      },
      ETH: (_) => async (v) => {
        var W;
        v && (d == null || d(_.id, await ht(v)), t && ((W = v.account) != null && W.address) && e.set(_.id, v.id)), a == null || a();
      }
    }, T = w.map(
      (_) => {
        var v;
        return _.on("connect", (v = A[_.id]) == null ? void 0 : v.call(A, _));
      }
    );
    return w.forEach((_) => {
      const v = S.current.has(_.id) ? null : _.connectedWallet;
      if (_.id === "ETH" && v) {
        ht(v).then((W) => d == null ? void 0 : d(_.id, W));
        return;
      }
      d == null || d(_.id, v);
    }), () => T.forEach((_) => _());
  }, [
    n,
    d,
    h,
    a,
    u,
    p,
    i,
    e,
    r,
    t,
    c
  ]), ue(() => {
    const A = Object.values(r).filter(Boolean).map(
      (T) => T.on("disconnect", (_) => {
        _ && (N.includes(T.id) && (I.current += 1, e.delete(X)), h == null || h(T.id), a == null || a(), t && e.delete(T.id));
      })
    );
    return () => A.forEach((T) => T());
  }, [h, a, r, t, e, N]), F(() => {
    const A = Object.values(r).filter(Boolean).map(
      (T) => T.on("error", (_) => {
        if (n == null || n(_), _ instanceof we && u) {
          const v = pi.get(_.code);
          if (v) {
            u({
              title: v(_.wallet ?? "your wallet"),
              description: _.message,
              submitButton: "",
              cancelButton: "Done",
              onCancel: () => {
                a == null || a();
              }
            });
            return;
          }
        }
        a == null || a();
      })
    );
    return () => A.forEach((T) => T());
  }, [n, a, u, r]);
  const K = U(async () => {
    const w = ++I.current;
    if (!C || !s && !D) return;
    const A = await Kn(C, N, r);
    if (w === I.current) {
      if (!A) {
        e.delete(X), g == null || g();
        return;
      }
      if (!o && !c) {
        f == null || f(C), a == null || a();
        return;
      }
      t && o && e.set(X, C);
    }
  }, [
    e,
    C,
    s,
    o,
    f,
    r,
    a,
    t,
    N,
    D,
    g,
    c
  ]);
  F(() => {
    K();
  }, [K]), ue(() => {
    const w = P.current;
    (!C || w && w !== C) && H.current.clear(), P.current = C;
  }, [C]), ue(() => {
    I.current += 1;
    const w = N.filter(
      (T) => !y.current.includes(T)
    );
    if (y.current = N, !C) return;
    const A = bt(
      C,
      xt(C),
      r,
      (T) => {
        if (!N.includes(T)) {
          H.current.add(T);
          return;
        }
        I.current += 1, e.delete(X), g == null || g();
      }
    );
    if (!s && !D) return A;
    if (!Fn(C, N, r) || w.some((T) => H.current.has(T)) || s && w.length > 0 && !Mn(C, w, r)) {
      A(), e.delete(X), g == null || g();
      return;
    }
    return s && w.length > 0 && (g == null || g(!0)), A;
  }, [
    e,
    C,
    s,
    r,
    N,
    D,
    g
  ]), F(
    () => () => {
      I.current += 1;
    },
    []
  );
  const G = U(
    async (w, A) => {
      const T = r[w.id];
      await (T == null ? void 0 : T.connect(A.id));
    },
    [r]
  ), b = U(
    async (w, A) => {
      if (A.connectGuide && l) {
        l(w.id, A.id);
        return;
      }
      await G(w, A);
    },
    [G, l]
  );
  return { connect: G, chooseWallet: b };
}
function Ii(t, e, n) {
  const i = U(
    (r, o) => /* @__PURE__ */ E(Ct, { children: o.map(({ id: s, widget: c }) => /* @__PURE__ */ E(
      c,
      {
        id: s,
        connector: t[r],
        createWallet: On,
        onError: n
      },
      s
    )) }),
    [t, n]
  );
  return j(
    () => e.reduce(
      (r, o) => ({
        ...r,
        [o.chain]: i(o.chain, o.connectors ?? [])
      }),
      {}
    ),
    [i, e]
  );
}
function Gt() {
  const {
    confirmed: t,
    chains: e,
    requiredChainIds: n,
    selectedWallets: i,
    open: r,
    displayChains: o,
    displayError: s,
    displayWallets: c,
    reset: d
  } = se(), h = Ae(), m = U(
    (u) => {
      u !== void 0 && Object.prototype.hasOwnProperty.call(e, u) ? c == null || c(u) : o == null || o(), r == null || r();
    },
    [e, o, c, r]
  ), a = U(
    async (u) => {
      var f;
      if (u !== void 0 && Object.prototype.hasOwnProperty.call(h, u)) {
        try {
          await ((f = h[u]) == null ? void 0 : f.disconnect("chain"));
        } catch (g) {
          throw Fe(g) && (s == null || s({
            title: "Wallets share one session",
            description: g.message,
            submitButton: "",
            cancelButton: "Done",
            onCancel: () => {
              o == null || o();
            }
          })), g;
        }
        return;
      }
      for (const g of Object.values(h))
        g && await g.disconnect("all");
      d == null || d();
    },
    [h, o, s, d]
  ), l = j(
    () => n.every((u) => !!i[u]),
    [n, i]
  );
  return {
    selected: l,
    connected: l && t,
    open: m,
    disconnect: a
  };
}
function Ci({
  className: t,
  alt: e,
  logo: n,
  title: i,
  description: r,
  optional: o,
  children: s,
  onClick: c
}) {
  const d = typeof n == "string" ? /* @__PURE__ */ E(rt, { url: n, alt: e }) : /* @__PURE__ */ E(rt, { children: n }), h = () => {
    if (typeof i == "string") {
      if (i.includes("Bitcoin")) return "select-bitcoin-wallet-button";
      if (i.includes("Ethereum")) return "select-ethereum-wallet-button";
      if (i.includes("Babylon")) return "select-babylon-wallet-button";
    }
    return "chain-button";
  };
  return /* @__PURE__ */ O(
    V,
    {
      as: "button",
      className: Z(
        "flex w-full cursor-pointer flex-col gap-4 rounded-lg bg-neutral-200 p-4 text-accent-primary",
        t
      ),
      onClick: c,
      "data-testid": h(),
      "data-optional": o,
      children: [
        /* @__PURE__ */ O("div", { className: "flex w-full items-center gap-2.5", children: [
          /* @__PURE__ */ E("div", { className: "flex items-center", children: d }),
          /* @__PURE__ */ O("div", { className: "flex flex-col text-left", children: [
            i,
            r && /* @__PURE__ */ E(V, { as: "span", variant: "body2", className: "text-accent-secondary", children: r })
          ] }),
          /* @__PURE__ */ E(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              className: "ml-auto block shrink-0 text-accent-secondary",
              children: /* @__PURE__ */ E(
                "path",
                {
                  d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                  fill: "currentColor"
                }
              )
            }
          )
        ] }),
        s && /* @__PURE__ */ E("div", { className: "w-full", children: s })
      ]
    }
  );
}
const wi = 36, mt = 14;
function Ni(t) {
  return t.length <= wi ? t : `${t.slice(0, mt)}…${t.slice(-mt)}`;
}
const Ti = Ze(({ className: t, logo: e, logoBackground: n, address: i }) => {
  const { isCopied: r, copyToClipboard: o } = En(), s = r(i), c = (d) => {
    d.stopPropagation(), o(i, i);
  };
  return /* @__PURE__ */ O("div", { className: Z("flex items-center gap-2.5 rounded-lg bg-neutral-200 p-2", t), children: [
    /* @__PURE__ */ E(Qe, { size: "small", className: "shrink-0", url: e, background: n }),
    /* @__PURE__ */ E(
      V,
      {
        as: "div",
        variant: "caption",
        title: i,
        className: "min-w-0 flex-1 truncate text-left font-mono text-accent-secondary",
        children: Ni(i)
      }
    ),
    /* @__PURE__ */ E(
      "span",
      {
        role: "button",
        tabIndex: 0,
        "aria-label": s ? "Address copied" : "Copy address",
        onClick: c,
        onKeyDown: (d) => {
          (d.key === "Enter" || d.key === " ") && c(d);
        },
        className: "flex shrink-0 cursor-pointer items-center text-accent-secondary hover:text-accent-primary",
        children: s ? /* @__PURE__ */ E(pn, { size: 16, variant: "success" }) : /* @__PURE__ */ E(gn, { size: 16 })
      }
    )
  ] });
}), Ai = "disabled:!bg-[#CCCCCC] dark:disabled:!bg-secondary-strokeDark", yi = "Select ", _i = " Wallet", vi = Ze(
  ({
    disabled: t = !1,
    chains: e,
    requiredChainIds: n,
    chainDescriptions: i,
    selectedWallets: r = {},
    className: o,
    onConfirm: s,
    onSelectChain: c
  }) => /* @__PURE__ */ O(
    "div",
    {
      className: Z(
        "flex flex-col overflow-hidden rounded-2xl border border-secondary-strokeLight text-accent-primary",
        o
      ),
      children: [
        /* @__PURE__ */ E("div", { className: "border-b border-secondary-strokeLight p-6", children: /* @__PURE__ */ E(Ce, { variant: "h5", className: "text-accent-primary", children: "Connect Wallets" }) }),
        /* @__PURE__ */ O("div", { className: "flex flex-col gap-4 p-6", children: [
          /* @__PURE__ */ O("div", { className: "flex flex-col gap-2", children: [
            e.map((d) => {
              var a;
              const h = r[d.id], m = n !== void 0 && !n.includes(d.id);
              return /* @__PURE__ */ E(
                Ci,
                {
                  title: `${yi}${d.name}${_i}`,
                  description: i == null ? void 0 : i[d.id],
                  optional: m,
                  logo: d.icon,
                  alt: d.name,
                  onClick: () => void (c == null ? void 0 : c(d)),
                  children: h && /* @__PURE__ */ E(
                    Ti,
                    {
                      logo: h.icon,
                      logoBackground: h.iconBackground,
                      address: ((a = h.account) == null ? void 0 : a.address) ?? ""
                    }
                  )
                },
                d.id
              );
            }),
            /* @__PURE__ */ E(
              Pe,
              {
                color: "secondary",
                disabled: t,
                fluid: !0,
                onClick: s,
                className: Z("text-sm disabled:!opacity-100", Ai),
                "data-testid": "chains-connect-button",
                children: "Connect"
              }
            )
          ] }),
          /* @__PURE__ */ O(V, { variant: "body2", className: "text-center text-accent-secondary", children: [
            "By clicking Connect you agree with the",
            " ",
            /* @__PURE__ */ E(
              "a",
              {
                href: "https://babylonlabs.io/terms-of-use",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-accent-primary underline",
                children: "Terms of Use"
              }
            ),
            " ",
            "and",
            " ",
            /* @__PURE__ */ E(
              "a",
              {
                href: "https://babylonlabs.io/privacy-policy",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-accent-primary underline",
                children: "Privacy Policy"
              }
            ),
            "."
          ] })
        ] })
      ]
    }
  )
);
function Ri() {
  typeof window < "u" && window.dispatchEvent(new Event(We));
}
function Si({ isChainHidden: t, ...e }) {
  const { chains: n, requiredChainIds: i, selectedWallets: r, displayWallets: o } = se(), { selected: s, disconnect: c } = Gt(), d = Ae(), h = j(
    () => Object.values(n).filter((a) => r[a.id] || !(t != null && t(a))),
    [n, t, r]
  ), m = U(
    async (a) => {
      if (a.id === "ETH" || a.id === "BTC") {
        const l = d[a.id], u = a.id === "ETH" ? Mt : zn, f = l == null ? void 0 : l.wallets.find((g) => g.id === u);
        if (f && (l == null ? void 0 : l.wallets.length) === 1) {
          const g = !!l.connectedWallet;
          try {
            g ? a.id === "ETH" && !Ut() ? Ri() : await c(a.id) : await l.connect(f.id);
          } catch (N) {
            Fe(N) || console.error(
              `Failed to ${g ? "disconnect" : "connect"} AppKit ${a.id}:`,
              N instanceof Error ? N.message : "Unknown error"
            );
          }
          return;
        }
      }
      o == null || o(a.id);
    },
    [o, d, c]
  );
  return /* @__PURE__ */ E(
    vi,
    {
      disabled: !s,
      chains: h,
      requiredChainIds: i,
      selectedWallets: r,
      onSelectChain: m,
      ...e
    }
  );
}
function Li({ name: t, logo: e, logoBackground: n, guide: i, onConnect: r }) {
  return /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ O(wt, { className: "flex flex-col gap-6 py-10", children: [
      /* @__PURE__ */ O("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ E(Qe, { className: "shrink-0", alt: t, url: e, background: n }),
        /* @__PURE__ */ E(Ce, { variant: "h5", className: "text-accent-primary", children: "Before you connect" })
      ] }),
      /* @__PURE__ */ E("ol", { className: "flex list-decimal flex-col gap-2 pl-5 text-accent-primary", children: i.steps.map((o) => /* @__PURE__ */ E(V, { as: "li", variant: "body2", children: o }, o)) }),
      i.installSteps && /* @__PURE__ */ O("div", { className: "flex flex-col gap-2 rounded-lg bg-neutral-100 p-4", children: [
        /* @__PURE__ */ E(V, { variant: "body2", className: "text-accent-primary", children: "Don't have the app yet?" }),
        /* @__PURE__ */ E("ol", { className: "flex list-decimal flex-col gap-2 pl-5 text-accent-secondary", children: i.installSteps.map((o) => /* @__PURE__ */ E(V, { as: "li", variant: "body2", children: o }, o)) })
      ] })
    ] }),
    /* @__PURE__ */ E(Nt, { children: /* @__PURE__ */ E(Pe, { fluid: !0, onClick: r, "data-testid": "connect-guide-connect-button", children: "Connect" }) })
  ] });
}
function Oi({ onConnect: t }) {
  var o;
  const { chains: e, screen: n } = se(), i = e[((o = n.params) == null ? void 0 : o.chain) ?? ""], r = i == null ? void 0 : i.wallets.find(({ id: s }) => {
    var c;
    return s === ((c = n.params) == null ? void 0 : c.wallet);
  });
  return !i || !(r != null && r.connectGuide) ? null : /* @__PURE__ */ E(
    Li,
    {
      name: r.name,
      logo: r.icon,
      logoBackground: r.iconBackground,
      guide: r.connectGuide,
      onConnect: () => t == null ? void 0 : t(i, r)
    }
  );
}
const Di = /* @__PURE__ */ E("svg", { xmlns: "http://www.w3.org/2000/svg", width: "52", height: "52", viewBox: "0 0 52 52", fill: "none", children: /* @__PURE__ */ E(
  "path",
  {
    d: "M2.16675 46.5837H49.8334L26.0001 5.41699L2.16675 46.5837ZM28.1667 40.0837H23.8334V35.7503H28.1667V40.0837ZM28.1667 31.417H23.8334V22.7503H28.1667V31.417Z",
    fill: "#387085"
  }
) });
function bi({
  className: t,
  icon: e = Di,
  title: n,
  description: i,
  cancelButton: r = "Cancel",
  submitButton: o = /* @__PURE__ */ O(Ct, { children: [
    "Continue ",
    /* @__PURE__ */ E("span", { className: "hidden md:inline", children: "Anyway" })
  ] }),
  onCancel: s,
  onSubmit: c
}) {
  return /* @__PURE__ */ O("div", { className: t, children: [
    /* @__PURE__ */ O(wt, { className: "py-16 text-center", children: [
      /* @__PURE__ */ E("div", { className: "mb-6 inline-flex size-20 items-center justify-center bg-primary-contrast text-primary-light", children: e }),
      /* @__PURE__ */ E(Ce, { variant: "h4", className: "mb-4 text-accent-primary", children: n }),
      /* @__PURE__ */ E(V, { as: "div", className: "text-accent-secondary", children: i })
    ] }),
    /* @__PURE__ */ O(Nt, { className: "flex gap-4", children: [
      r && /* @__PURE__ */ E(Pe, { variant: "outlined", fluid: !0, onClick: s, children: r }),
      o && /* @__PURE__ */ E(Pe, { fluid: !0, onClick: c, "data-testid": "error-continue-button", children: o })
    ] })
  ] });
}
function xi({ className: t }) {
  const { screen: e } = se(), { icon: n, title: i, description: r, cancelButton: o, submitButton: s, onCancel: c, onSubmit: d } = e.params ?? {};
  return /* @__PURE__ */ E(
    bi,
    {
      className: t,
      icon: n,
      title: i,
      description: r,
      cancelButton: o,
      submitButton: s,
      onCancel: c,
      onSubmit: d
    }
  );
}
function Pi({ className: t, title: e, description: n }) {
  return /* @__PURE__ */ O("div", { className: Z("flex flex-col items-center justify-center gap-6", t), children: [
    /* @__PURE__ */ E("div", { className: "flex items-center justify-center bg-primary-contrast p-6", children: /* @__PURE__ */ E(In, { className: "text-primary-light" }) }),
    (e || n) && /* @__PURE__ */ O("div", { className: "flex flex-col items-center gap-2 text-center", children: [
      e && /* @__PURE__ */ E(Ce, { variant: "h4", className: "capitalize text-accent-primary", children: e }),
      n && /* @__PURE__ */ E(V, { as: "div", className: "text-accent-secondary", children: n })
    ] })
  ] });
}
const Wi = "text-[#15B768] dark:text-[#00E676]", Bi = "bg-[#15B768] dark:bg-[#00E676]", Hi = "text-[#FFB300]", Mi = "bg-[#FFB300]";
function Fi({
  className: t,
  disabled: e = !1,
  name: n,
  logo: i,
  logoBackground: r,
  fallbackLink: o,
  installed: s = !0,
  hardware: c = !1,
  label: d,
  onClick: h
}) {
  const a = s || c ? { as: "button", disabled: e, onClick: h } : { as: "a", href: o, target: "_blank", rel: "noopener noreferrer" }, l = () => {
    const u = n.toLowerCase();
    return u.includes("okx") ? "wallet-option-okx" : u.includes("keplr") ? "wallet-option-keplr" : u.includes("leap") ? "wallet-option-leap" : `wallet-option-${u.replace(/\s+/g, "-")}`;
  };
  return /* @__PURE__ */ O(
    V,
    {
      variant: "body2",
      className: Z(
        "flex h-14 w-full items-center gap-2.5 rounded-lg p-2 text-accent-primary",
        s ? "bg-neutral-200" : "bg-neutral-100",
        e ? "cursor-default" : "cursor-pointer",
        t
      ),
      ...a,
      "data-testid": l(),
      children: [
        /* @__PURE__ */ E(Qe, { className: "shrink-0", alt: n, url: i, background: r }),
        /* @__PURE__ */ E("span", { className: Z("min-w-0 flex-1 truncate text-left", !s && "text-accent-secondary"), children: n }),
        /* @__PURE__ */ O(
          Cn,
          {
            className: Z(
              "flex shrink-0 items-center gap-1.5 rounded-full",
              s ? "bg-neutral-100" : "bg-neutral-200"
            ),
            children: [
              (c || s) && /* @__PURE__ */ E("span", { className: Z("size-2 rounded-full", c ? Mi : Bi) }),
              /* @__PURE__ */ E("span", { className: c ? Hi : s ? Wi : "text-accent-secondary", children: c ? d : s ? "Installed" : "Uninstalled" })
            ]
          }
        )
      ]
    }
  );
}
const Ki = {
  [Q.MAINNET]: "bc1p",
  [Q.TESTNET]: "tb1p",
  [Q.SIGNET]: "tb1p"
}, Ui = "https://tbv-faucet.testnet.babylonlabs.io/", Et = (t) => t.installed && !t.hardware ? 0 : t.hardware ? 1 : 2, Gi = Ze(({ chain: t, className: e, append: n, onSelectWallet: i }) => {
  const r = j(
    () => t.wallets.filter((c) => c.id === "injectable" ? c.installed : !0).sort((c, d) => Et(c) - Et(d)),
    [t]
  ), o = j(() => {
    var h;
    if (t.id !== "BTC") return null;
    const c = (h = t.config) == null ? void 0 : h.network, d = c ? Ki[c] : void 0;
    return d ? { prefix: d, showFaucet: c !== Q.MAINNET } : null;
  }, [t]), s = U(
    async (c) => {
      i == null || i(t, c);
    },
    [t, i]
  );
  return /* @__PURE__ */ O("div", { className: Z("flex flex-col overflow-hidden rounded-2xl border border-secondary-strokeLight", e), children: [
    /* @__PURE__ */ O("div", { className: "flex flex-col gap-2 border-b border-secondary-strokeLight p-6", children: [
      /* @__PURE__ */ E(Ce, { variant: "h5", className: "text-accent-primary", children: `Select ${t.name} Wallet` }),
      o && /* @__PURE__ */ O(V, { variant: "body2", className: "text-accent-secondary", children: [
        `To continue, connect a ${t.name} wallet with a `,
        /* @__PURE__ */ E("span", { className: "text-accent-primary", children: `${o.prefix} (Taproot)` }),
        " address.",
        o.showFaucet && /* @__PURE__ */ O("span", { className: "block", children: [
          " Don't have testnet BTC yet? Get it from ",
          /* @__PURE__ */ E(
            "a",
            {
              href: Ui,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "text-accent-primary underline underline-offset-2 transition-opacity hover:opacity-80",
              children: "Faucet"
            }
          ),
          "."
        ] })
      ] })
    ] }),
    /* @__PURE__ */ O("div", { className: "flex flex-col gap-2 p-6", children: [
      r.map((c) => /* @__PURE__ */ E(
        Fi,
        {
          installed: c.installed,
          hardware: c.hardware,
          label: c.label,
          name: c.name,
          logo: c.icon,
          logoBackground: c.iconBackground,
          fallbackLink: c.docs,
          onClick: () => s(c)
        },
        c.id
      )),
      n
    ] })
  ] });
});
function ki({ widgets: t = {}, ...e }) {
  var c;
  const { chains: n, screen: i } = se(), r = ((c = i.params) == null ? void 0 : c.chain) ?? "", o = n == null ? void 0 : n[r], s = t == null ? void 0 : t[r];
  return /* @__PURE__ */ E(Gi, { append: s, chain: o, ...e });
}
const pt = {
  CHAINS: ({ onConfirm: t, chainDescriptions: e, isChainHidden: n }) => /* @__PURE__ */ E(Si, { onConfirm: t, chainDescriptions: e, isChainHidden: n }),
  WALLETS: ({ widgets: t, onSelectWallet: e }) => /* @__PURE__ */ E(ki, { widgets: t, onSelectWallet: e }),
  CONNECT_GUIDE: ({ onConnectWallet: t }) => /* @__PURE__ */ E(Oi, { onConnect: t }),
  LOADER: ({ current: t }) => {
    var e, n;
    return /* @__PURE__ */ E(Pi, { title: (e = t == null ? void 0 : t.params) == null ? void 0 : e.message, description: (n = t == null ? void 0 : t.params) == null ? void 0 : n.description });
  },
  ERROR: () => /* @__PURE__ */ E(xi, {}),
  EMPTY: () => /* @__PURE__ */ E("div", {})
};
function ji(t) {
  const e = pt[t.current.type] ?? pt.EMPTY;
  return /* @__PURE__ */ E(e, { ...t });
}
const de = "Wallet changed while confirming", zi = "Wallet did not report its network", Vi = "Wallet network does not match the configured network", Yi = "Connected wallet has no provider";
function $i(t, e) {
  for (const n of e) {
    const i = t.find(({ chain: r }) => r === n);
    if (i) return i;
  }
  return t[0];
}
function Xe(t) {
  return Object.entries(t).flatMap(([e, n]) => {
    const i = n == null ? void 0 : n.connectedWallet;
    return i != null && i.account ? [{ chain: e, wallet: i, account: { ...i.account } }] : [];
  });
}
function gt(t) {
  return t.map(({ chain: e, wallet: n, account: i }) => {
    const r = { ...i }, o = {
      id: n.id,
      name: n.name,
      icon: n.icon,
      iconBackground: n.iconBackground,
      docs: n.docs,
      installed: n.installed,
      provider: n.provider,
      account: r,
      label: n.label,
      hardware: n.hardware
    };
    return { chain: e, wallet: o, account: r };
  });
}
function Xi(t, e, n) {
  return t.every(({ chain: i, wallet: r, provider: o, receipt: s }) => {
    const c = e.find((d) => d.chain === i);
    return c ? c.wallet === r && c.provider === o && c.receipt === s : !n.includes(i);
  });
}
async function It(t, e, n) {
  const i = t(), r = Xe(i).map((l) => ({
    connection: l,
    provider: l.wallet.provider,
    receipt: Ee([l], i)
  })), s = (await Promise.all(
    r.map(async (l) => {
      var g, N;
      const { chain: u } = l.connection, { provider: f } = l;
      try {
        if (!f) throw new Error(`${Yi}: ${u}`);
        if (((g = f.isIdentityCurrent) == null ? void 0 : g.call(f)) === !1)
          throw new Error(de);
        let p;
        if (u === "ETH" || u === "BTC") {
          if (p = u === "ETH" ? await f.getChainId() : await f.getNetwork(), p == null || !String(p))
            throw new Error(zi);
          if (Ee([l.connection], i, { [u]: p }) !== l.receipt)
            throw new Error(Vi);
        }
        const [I, y] = await Promise.all([f.getAddress(), f.getPublicKeyHex()]);
        if (!I || !y || !ce(I, l.connection.account.address) || !ce(y, l.connection.account.publicKeyHex))
          throw new Error(de);
        if (((N = f.isIdentityCurrent) == null ? void 0 : N.call(f)) === !1)
          throw new Error(de);
        return {
          ...l,
          connection: { ...l.connection, account: { address: I, publicKeyHex: y } }
        };
      } catch (p) {
        if (e.includes(u)) throw p;
        return n == null || n(p instanceof Error ? p : new Error("Optional wallet verification failed")), null;
      }
    })
  )).filter(
    (l) => l !== null
  ), c = t(), d = Xe(c), h = s.flatMap((l) => {
    const { connection: u, receipt: f } = l, g = d.find(({ chain: p }) => p === u.chain);
    if (!!(g && g.wallet === u.wallet && g.wallet.provider === l.provider && Ee([g], c) === f)) return [l];
    if (e.includes(u.chain)) throw new Error(de);
    return n == null || n(new Error(de)), [];
  }), m = h.map(({ connection: l }) => l), a = h.map(({ connection: l, provider: u, receipt: f }) => ({
    chain: l.chain,
    wallet: l.wallet,
    provider: u,
    receipt: f
  }));
  return {
    receipt: Ee(m, c),
    connections: m,
    identities: Object.freeze(a)
  };
}
function Ar({
  persistent: t,
  storage: e,
  config: n,
  onError: i,
  btcValidation: r,
  actions: o,
  closeButtonClassName: s,
  actionsClassName: c,
  chainDescriptions: d,
  isChainHidden: h
}) {
  const {
    visible: m,
    screen: a,
    confirmed: l,
    requiredChainIds: u,
    close: f,
    confirm: g,
    unconfirm: N,
    displayChains: p,
    displayWallets: I,
    displayError: y
  } = se(), { acceptTermsOfService: C, onConfirm: P } = Ht(), H = Ae(), D = Ii(H, n, i), { connect: S, chooseWallet: R } = gi({
    persistent: t,
    accountStorage: e,
    onError: i,
    btcValidation: r
  }), K = M(H), G = M(0), b = M(null), w = M(null), A = M(!1), T = M(m), _ = M(l), v = M({ persistent: t, requiredChainIds: [...u], storage: e }), W = U(() => {
    const x = w.current;
    w.current = null, G.current += 1, b.current = null, x == null || x();
  }, []);
  ue(() => {
    K.current = H, (T.current && !m || !_.current && l) && W(), T.current = m, _.current = l;
  }, [l, H, W, m]), ue(() => (A.current = !0, () => {
    A.current = !1, W();
  }), [W]), ue(() => {
    const x = v.current, z = x.requiredChainIds.length !== u.length || x.requiredChainIds.some((ne, Re) => ne !== u[Re]);
    (x.persistent !== t || x.storage !== e || z) && W(), v.current = { persistent: t, requiredChainIds: [...u], storage: e };
  }, [W, t, u, e]);
  const ye = U(() => {
    W(), f == null || f();
  }, [f, W]), _e = U(async () => {
    if (b.current !== null || !A.current || !T.current) return;
    const x = G.current + 1;
    G.current = x, b.current = x;
    const z = () => b.current === x && G.current === x && A.current && T.current;
    let ne = () => {
    }, Re = !1;
    try {
      if (!l) {
        const ae = K.current, me = Ee(Xe(ae), ae), jt = bt(
          me,
          xt(me),
          ae,
          () => {
            W(), e.delete(X), N == null || N();
          }
        );
        let et = !0;
        if (ne = () => {
          et && (et = !1, jt());
        }, !z()) {
          ne();
          return;
        }
        w.current = ne;
        const Se = await It(
          () => K.current,
          u,
          i
        );
        if (!z()) return;
        const { connections: Le } = Se, Ue = u.filter((Ge) => !Le.some(({ chain: zt }) => zt === Ge));
        if (Ue.length > 0)
          throw new Error(
            `No connected account for required chain${Ue.length > 1 ? "s" : ""}: ${Ue.join(", ")}`
          );
        const Oe = $i(Le, u), tt = async () => {
          if (!z()) return !1;
          const Ge = await It(
            () => K.current,
            u,
            i
          );
          if (!z()) return !1;
          if (!Xi(Se.identities, Ge.identities, u))
            throw new Error(de);
          return !0;
        };
        if (Oe && (await (C == null ? void 0 : C({
          address: Oe.account.address,
          public_key: Oe.account.publicKeyHex,
          chain: Oe.chain,
          connections: gt(Le)
        })), !await tt()) || (await (P == null ? void 0 : P(gt(Le))), !await tt()) || (t && e.set(X, Se.receipt), !z()) || (g == null || g(Se.receipt), !z())) return;
        Re = !!g;
      }
      if (!z()) return;
      f == null || f();
    } catch (ae) {
      if (!z()) return;
      const me = ae instanceof Error ? ae : new Error("Wallet confirmation failed");
      if (i == null || i(me), !z()) return;
      y == null || y({
        title: "Connection Failed",
        description: me.message,
        submitButton: "",
        cancelButton: "Done",
        onCancel: p
      });
    } finally {
      Re || (ne(), w.current === ne && (w.current = null), G.current === x && b.current === x && (b.current = null));
    }
  }, [
    C,
    f,
    g,
    l,
    p,
    y,
    W,
    P,
    i,
    t,
    u,
    e,
    N
  ]), ve = a.type === "WALLETS" ? p : a.type === "CONNECT_GUIDE" ? () => {
    var x;
    return I == null ? void 0 : I((x = a.params) == null ? void 0 : x.chain);
  } : void 0;
  return /* @__PURE__ */ E(
    wn,
    {
      open: m,
      onClose: ye,
      onBack: ve,
      className: "items-center justify-center p-6",
      actions: o,
      closeButtonClassName: s,
      actionsClassName: c,
      children: /* @__PURE__ */ E("div", { className: "mx-auto w-full max-w-[612px]", children: /* @__PURE__ */ E(
        ji,
        {
          current: a,
          widgets: D,
          onConfirm: _e,
          onSelectWallet: R,
          onConnectWallet: S,
          chainDescriptions: d,
          isChainHidden: h
        }
      ) })
    }
  );
}
function Zi(t, e) {
  const { enabled: n, delay: i = 500 } = e, r = M(null);
  F(() => {
    if (!n || typeof window > "u" || typeof document > "u") return;
    const o = () => {
      document.visibilityState === "visible" && (r.current && clearTimeout(r.current), r.current = setTimeout(() => {
        Promise.resolve(t()).catch((s) => {
          console.error("Error in visibility check callback:", s instanceof Error ? s.message : "Unknown error");
        });
      }, i));
    };
    return document.addEventListener("visibilitychange", o), () => {
      document.removeEventListener("visibilitychange", o), r.current && (clearTimeout(r.current), r.current = null);
    };
  }, [n, t, i]);
}
const kt = ge({
  loading: !0,
  connected: !1,
  address: void 0,
  disconnect: () => {
  },
  open: () => {
  }
}), yr = ({ children: t, callbacks: e }) => {
  const [n, i] = le(!0), [r, o] = le(), [s, c] = le(null), { open: d, disconnect: h } = Gt(), m = hi("ETH"), a = U(async () => {
    try {
      await (m == null ? void 0 : m.disconnect("local"));
    } catch (p) {
      console.error("Failed to disconnect ETH connector:", p instanceof Error ? p.message : "Unknown error");
    }
  }, [m]), l = U(
    async (p) => {
      var I, y;
      try {
        o(p), i(!1), await ((I = e == null ? void 0 : e.onConnect) == null ? void 0 : I.call(e, p));
      } catch (C) {
        i(!1), (y = e == null ? void 0 : e.onError) == null || y.call(e, C instanceof Error ? C : new Error("ETH connection failed"), {
          address: p
        });
      }
    },
    [e]
  );
  F(() => {
    if (i(!1), !m) return;
    (async () => {
      var D;
      try {
        if ((D = m.connectedWallet) != null && D.provider && !r) {
          const S = m.connectedWallet.provider, R = await S.getAddress();
          R && (c(S), l(R));
          return;
        }
        if (!r && m.wallets.length > 0) {
          const S = m.wallets[0];
          if (S.provider)
            try {
              await S.provider.getAddress() && await m.connect(S);
            } catch {
            }
        }
      } catch {
      }
    })();
    const I = m.on("connect", async (D) => {
      if (D.provider)
        try {
          const S = await D.provider.getAddress();
          S && (c(D.provider), l(S));
        } catch (S) {
          console.error("Error getting ETH address:", S instanceof Error ? S.message : "Unknown error");
        }
    }), y = m.wallets[0], C = y == null ? void 0 : y.provider;
    let P = !1;
    const H = (D) => {
      !(D != null && D[0]) || r || P || (P = !0, m.connect(y).then((S) => {
        S || (P = !1);
      }).catch((S) => {
        P = !1, console.error("ETH late reconnect failed:", S instanceof Error ? S.message : "Unknown error");
      }));
    };
    return C && typeof C.on == "function" && C.on("accountsChanged", H), () => {
      I(), C && typeof C.off == "function" && C.off("accountsChanged", H);
    };
  }, [m, l, r]), F(() => {
    if (m)
      return m.on("disconnect", async () => {
        var p;
        o(void 0), c(null);
        try {
          await ((p = e == null ? void 0 : e.onDisconnect) == null ? void 0 : p.call(e));
        } catch (I) {
          console.error("Error in onDisconnect callback:", I instanceof Error ? I.message : "Unknown error");
        }
      });
  }, [m, e]);
  const u = M(void 0), f = M(!1);
  F(() => {
    u.current = r;
  }, [r]), F(() => {
    if (!s) return;
    const p = async (I) => {
      var P, H;
      if (f.current) return;
      const y = I[0], C = u.current;
      if (y && y.toLowerCase() !== (C == null ? void 0 : C.toLowerCase())) {
        f.current = !0, u.current = y, o(y);
        try {
          await ((P = e == null ? void 0 : e.onAddressChange) == null ? void 0 : P.call(e, y));
        } catch (D) {
          (H = e == null ? void 0 : e.onError) == null || H.call(e, D instanceof Error ? D : new Error("ETH address change failed"), {
            address: y
          });
        } finally {
          f.current = !1;
        }
      } else !y && C && a();
    };
    return typeof s.on == "function" && s.on("accountsChanged", p), () => {
      typeof s.off == "function" && s.off("accountsChanged", p);
    };
  }, [s, e, a]);
  const g = U(async () => {
    var p;
    if (s)
      try {
        const I = await s.getAddress();
        I ? I.toLowerCase() !== (r == null ? void 0 : r.toLowerCase()) && (u.current = I, o(I), await ((p = e == null ? void 0 : e.onAddressChange) == null ? void 0 : p.call(e, I))) : a();
      } catch (I) {
        console.error("ETH wallet connection check failed:", I instanceof Error ? I.message : "Unknown error"), a();
      }
  }, [s, r, e, a]);
  Zi(g, {
    enabled: !!(s && r)
  });
  const N = j(() => !!r, [r]);
  return /* @__PURE__ */ E(
    kt.Provider,
    {
      value: {
        loading: n,
        connected: N,
        address: r,
        disconnect: () => h("ETH"),
        open: d
      },
      children: t
    }
  );
}, _r = () => Ie(kt);
export {
  We as A,
  se as B,
  Er as C,
  St as D,
  oe as E,
  mr as F,
  Kt as G,
  ke as H,
  Cr as I,
  Mt as J,
  oi as K,
  pr as L,
  kn as M,
  Q as N,
  Ir as O,
  lr as P,
  Ve as Q,
  Fe as R,
  yr as S,
  _r as T,
  Pt as U,
  Gn as V,
  we as W,
  Nr as X,
  Rt as a,
  hr as b,
  zn as c,
  ur as d,
  Zn as e,
  k as f,
  qe as g,
  fi as h,
  ar as i,
  ei as j,
  On as k,
  gr as l,
  wr as m,
  fr as n,
  jn as o,
  _n as p,
  Tr as q,
  Qn as r,
  qn as s,
  dr as t,
  hi as u,
  Jn as v,
  Ar as w,
  Gt as x,
  vt as y,
  Zi as z
};
//# sourceMappingURL=ETHWalletProvider-CP5ssaJi.js.map
